module.exports = __webpack_public_path__ + "static/media/expense-pink.7d4a5301.svg";